/**
 * MobileSubMenu — Collapsible accordion for mobile nav sub-links.
 * Uses Radix Collapsible for accessible keyboard expand/collapse.
 */

import * as React from 'react';
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '../../collapsible';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../../utils/cn';
import styles from './global-header.module.css';
import type { NavLink } from './GlobalHeader';

interface MobileSubMenuProps {
  link: NavLink;
  onNavigate: () => void;
}

export function MobileSubMenu({ link, onNavigate }: MobileSubMenuProps) {
  const [open, setOpen] = React.useState(false);

  return (
    <Collapsible open={open} onOpenChange={setOpen} className={styles.mobileSubMenu}>
      <CollapsibleTrigger asChild>
        <button
          type="button"
          className={cn(styles.mobileNavLink, 'font-medium')}
          aria-expanded={open}
        >
          <span>{link.title}</span>
          <ChevronDown
            size={16}
            aria-hidden="true"
            className={cn(styles.subChevron, open && styles.subChevronOpen)}
          />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className={styles.mobileSubContent}>
        {link.subLinks?.map((sub) => (
          <a
            key={sub.url}
            href={sub.url}
            className={cn(styles.mobileNavLink, styles.mobileSubLink)}
            onClick={onNavigate}
          >
            {sub.title}
          </a>
        ))}
      </CollapsibleContent>
    </Collapsible>
  );
}

MobileSubMenu.displayName = 'MobileSubMenu';
